import { render } from "./Pamphlet.vue?vue&type=template&id=a544560a"
import script from "./Pamphlet.vue?vue&type=script&lang=js"
export * from "./Pamphlet.vue?vue&type=script&lang=js"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__